import validate from "/root/injective/injective-bridge/node_modules/nuxt/dist/pages/runtime/validate.js";
import dev_45mode_45global from "/root/injective/injective-bridge/middleware/dev-mode.global.ts";
import maintenance_45global from "/root/injective/injective-bridge/middleware/maintenance.global.ts";
import route_45change_45global from "/root/injective/injective-bridge/middleware/route-change.global.ts";
import manifest_45route_45rule from "/root/injective/injective-bridge/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  dev_45mode_45global,
  maintenance_45global,
  route_45change_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-dev-mode": () => import("/root/injective/injective-bridge/middleware/is-dev-mode.ts")
}